export default {
  methods: {
    removeImgTags(text) {
      return text.replace(/<img.*?>/g, 'Imagen');
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/removeImgTags.js